module.exports = __webpack_public_path__ + "static/media/tablet.2a7a3249.svg";